import { Controller } from "@hotwired/stimulus"

// Poll /admin/analytics/realtime.json toutes les N ms et met à jour les KPI
// de la page admin/analytics/realtime (vue dédiée "Temps réel").
export default class extends Controller {
  static targets = ["activeVisitors", "uniqueVisitors", "totalVisits", "recentEvents"]
  static values  = { url: String, interval: { type: Number, default: 30000 } }

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, {
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin"
      })
      if (!res.ok) return
      const data = await res.json()
      this._set(this.hasActiveVisitorsTarget && this.activeVisitorsTarget, data.active_visitors)
      this._set(this.hasUniqueVisitorsTarget && this.uniqueVisitorsTarget, data.unique_visitors)
      this._set(this.hasTotalVisitsTarget    && this.totalVisitsTarget,    this._fmt(data.total_visits))
      this._set(this.hasRecentEventsTarget   && this.recentEventsTarget,   this._fmt(data.recent_events))
    } catch (_e) {
      // silencieux — la prochaine itération réessayera
    }
  }

  _set(target, val) {
    if (!target || val == null) return
    if (target.textContent.trim() !== String(val)) {
      target.textContent = val
    }
  }

  _fmt(n) {
    if (n == null) return n
    return Number(n).toLocaleString("fr-FR")
  }
}
